import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { Metrika } from 'ng-yandex-metrika';
import { MetrikaGoalNameEnum } from '../enums/metrika-goal-name.enum';

@Injectable({ providedIn: 'root' })
export class YandexMetrikaService {
	prevPath: string = '';
	constructor(private location: Location, private metrika: Metrika) {
		this.prevPath = this.location.path();
	}

	hit(virtualUrl?: string) {
		let newPath = virtualUrl ? `${this.location.path()}/${virtualUrl}` : this.location.path();
		this.metrika.hit(newPath, {
			referer: this.prevPath,
		});
		this.prevPath = newPath;
	}

	sendGoal(goalName: MetrikaGoalNameEnum) {
		this.metrika.reachGoal(goalName);
	}

	hitBanner(bannerId: string) {
		let path = `${this.prevPath}/from?=${bannerId}`;
		this.metrika.hit(path);
	}
}
